import { Validator } from 'redux-form';
import NumberField from '../fields/NumberField';
import DatePicker from '../fields/DatePicker';
import { AttachmentsField } from '../fields/AttachmentsField';
import WaterfallSelectFieldComponent from '../fields/WaterfallSelectFieldComponent';
import { MultipleResourcePickerSmart } from '../../../main/src/components/app/layout/Contracts/prefabs/MultipleResourcePicker';
import { SelectField } from '../fields/SelectField';
import { TextField } from '../fields/TextField';
import { PasswordField } from '../fields/PasswordField';
import { CheckboxField } from '../fields/CheckboxField';
import { AuthCodeField } from '../fields/AuthCodeField';
import { RecipientsPicker } from '@cube3/main/src/components/app/layout/shares/prefabs/RecipientsPicker';
import { PasswordRow } from '@cube3/main/src/components/app/layout/shares/prefabs/PasswordRow';
import { ExpirationDatePicker } from '@cube3/main/src/components/app/layout/shares/prefabs/ExpirationDatePicker';
import { PhoneField } from '../fields/PhoneField';
import { Field, WrappedFieldState } from '../types/GenericFormTypes';
import MultipleSelectField from '../fields/MultipleSelectField';
import { RadioField } from '../fields/RadioField';
import { Divider } from '@cube3/cubicle/src/core/atoms/Divider/Divider';

export const getFieldConfig = (field: Field & WrappedFieldState) => {
  const { type } = field;

  switch (type) {
    case 'divider':
      return {
        Component: Divider,
        props: {
          ...field
        }
      };
    case 'string':
    case 'email':
    case 'text': {
      // assign the `form` attribute to an input element can confuse password managers,
      // it might skip or misidentify such inputs.
      const { form, ...restField } = field;
      return {
        Component: TextField,
        props: {
          fullWidth: true,
          ...restField,
          multiline: 1,
          'data-pw': 'textField'
        }
      };
    }
    case 'textarea':
      return {
        Component: TextField,
        props: {
          ...field,
          'data-pw': 'textareaField',
          autoResize: true
        }
      };
    case 'password': {
      // assign the `form` attribute to an input element can confuse password managers,
      // it might skip or misidentify such inputs.
      const { form, ...restField } = field;
      return {
        Component: PasswordField,
        props: {
          ...restField,
          'data-pw': 'passwordField'
        }
      };
    }
    case 'checkbox':
      return {
        Component: CheckboxField,
        props: {
          ...field,
          'data-pw': 'checkboxField'
        }
      };

    case 'authentication':
      return {
        Component: AuthCodeField,
        props: {
          ...field,
          'data-pw': 'authenticationField'
        }
      };

    case 'select': {
      return {
        Component: SelectField,
        props: {
          ...field,
          'data-pw': 'selectField',
          'data-cy': 'metadataSelectField'
        }
      };
    }
    case 'multistring':
    case 'recipients':
      return {
        Component: RecipientsPicker,
        props: {
          ...field,
          locked: (field as Field<string, 'recipients'>).locked
        }
      };
    case 'generate_password':
      return {
        Component: PasswordRow,
        props: {
          ...field
        }
      };
    case 'expires_at':
      return {
        Component: ExpirationDatePicker,
        props: {
          ...field,
          error: field.showErrors
        }
      };
    case 'radio':
      return {
        Component: RadioField,
        props: {
          ...field
        }
      };
    /*
     
    TODO: replace with cubicle components

    */
    case 'number':
      return {
        Component: NumberField,
        props: {
          ...field,
          inputProps: {
            // Label will be added in a Wrapping component, unset it here to prevent label twice
            label: undefined,
            type: 'text',
            'data-pw': 'numberField'
          }
        }
      };
    case 'date': {
      return {
        Component: DatePicker,
        props: {
          ...field,
          //  warning: field.warning,
          fullWidth: false,
          type: 'string',
          inputProps: {
            disabled: field.disabled,
            'data-pw': 'datePickerField',
            'data-cy': 'metadataDateField'
          }
        }
      };
    }
    case 'multiselect':
      return {
        Component: MultipleSelectField,
        props: {
          ...field,
          //  allowAddingOfNewSuggestions: false,
          validator: (val) => (field.validate as Validator)?.(val),
          // clearOn: 'all',
          // inputType: field.type,
          'data-pw': 'multiselectField'
        }
      };

    case 'waterfall_select':
      return {
        Component: WaterfallSelectFieldComponent,
        props: {
          ...field,
          showClearButton: !field.required,
          selectProps: { 'data-pw': 'metadataWaterfallSelectField' }
        }
      };

    case 'phone_number':
      return {
        Component: PhoneField,
        props: {
          ...field,
          multiline: 1,
          placeholder: '+31 6 555 555 555',
          inputProps: {
            'data-pw': 'phoneNumberField'
          }
        }
      };

    case 'asset':
      return {
        Component: AttachmentsField,
        props: {
          ...field,
          metadataForResource: (field as Field<unknown, 'asset'>)
            .metadataForResource,
          inputProps: { 'data-pw': 'attachmentField' }
        }
      };
    case 'resource_picker':
      return {
        Component: MultipleResourcePickerSmart as (props) => JSX.Element,
        props: {
          ...field,
          inputProps: { 'data-pw': 'resourcePickerField' }
        }
      };

    case 'custom': {
      const { component, ...config } = field;
      return {
        Component: component,
        props: {
          ...config,
          'data-pw': 'customField'
        }
      };
    }

    default:
      return {
        Component: TextField,
        props: {
          ...field,
          multiline: 1
        }
      };
  }
};
